import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import { bool, shape } from "prop-types";
import { useLocation } from "react-router-dom";

import * as i18n from "util/i18n";
import * as Yup from "yup";
import useSchema from "hooks/useSchema";

import { Mixpanel } from "util/clickstreaming";
import { routerActions } from "connected-react-router";
import { actions as settingsActions } from "reducers/settings";
import { actions as cedipActions, types } from "reducers/cedip";

import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
import AmountField from "pages/_components/fields/formik/AmountField";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import FieldLabel from "pages/_components/fields/FieldLabel";
import { Col, Row } from "react-bootstrap";
import Beneficiaries from "../components/Beneficiaries";

import TermsConditionTransmit from "../components/TermsConditionTransmit";

const FORM_ID = "cedip.transmit";
const FILENAME_CATEGORY = "transmitCedip";
const ARS = "ARS";

const TransmitCedip = (props) => {
    const { match, isDesktop } = props;
    const dispatch = useDispatch();
    const [openSidebar, setOpenSidebar] = useState(false);
    const { cedipList, generalConditionsShowTransmit } = useSelector((state) => state.cedip);
    const { documents } = useSelector((state) => state.settings);
    const { cedipsLength = cedipList.length, selectedCedip, transmitCedipData } = useSelector((state) => state.cedip);
    const { state = { accountId: "" } } = useLocation();
    const { numberRequired, stringRequired } = useSchema();
    const hasBeneficiary = transmitCedipData?.beneficiary?.reference;
    const fetching = selectedCedip !== undefined && selectedCedip.cedipId !== null;

    useEffect(() => {
        if (!cedipsLength && cedipsLength === 0) {
            const receivedCedipFilters = {
                createdFrom: null,
                createdTo: null,
                expiredFrom: null,
                expiredTo: null,
                cedipId: match.params.id,
                status: "TODOS",
                pageNumber: 1,
                tabSelected: "ALL",
            };
            dispatch(cedipActions.filterCedipList({ ...receivedCedipFilters }));
        }
    }, [match.params.id]);

    useEffect(() => {
        dispatch(cedipActions.readCedip(match.params.id));
        dispatch(cedipActions.setTransmitCedip({}));
        dispatch(settingsActions.loadDocumentsRequest(FILENAME_CATEGORY));
        dispatch(cedipActions.getTermTransmit());
    }, [cedipsLength]);

    const initialValues = {
        idAccount: selectedCedip?.idAccount || state?.accountId || "",
        tipoTransmision: "NOM",
        typeTransmit: i18n.get("cedips.transmissions.type.NOM"),
        amountField: {
            amount: selectedCedip?.montoDepositado || 0,
        },
    };

    const handleSubmit = (values) => {
        dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT"));

        dispatch(
            cedipActions.setTransmitCedip({
                ...transmitCedipData,
                amount: values.amountField.amount,
                tipoTransmision: values.tipoTransmision,
            }),
        );

        if (generalConditionsShowTransmit) {
            setOpenSidebar(true);
        } else {
            dispatch(
                routerActions.push(`/cedip/transmit/confirmation`, {
                    scopeToShow: "cedip/transmit/confirm",
                    idActivity: "transmit.cedip.pre",
                    idTitle: "cedip.transmit",
                }),
            );
        }
    };

    const handleAccept = () => {
        setOpenSidebar(false);
        Mixpanel.track(FORM_ID, { acceptConditions: true });
        dispatch(cedipActions.acceptTermTransmit());
        dispatch(
            routerActions.push(`/cedip/transmit/confirmation`, {
                scopeToShow: "cedip/transmit/confirm",
                idActivity: "transmit.cedip.pre",
                idTitle: "cedip.transmit",
            }),
        );
    };

    const handleClickDownloadPdf = () => {
        dispatch(settingsActions.downloadDocumentRequest(documents[0]?.fileNameKey, FILENAME_CATEGORY));
    };

    const transmitCedipValidation = Yup.lazy(() => {
        let validate = {
            typeTransmit: stringRequired,
        };

        validate = {
            ...validate,
            amountField: Yup.object()
                .shape({
                    amount: numberRequired,
                })
                .test("amountField", "Monto incorrecto", () => true),
        };

        return Yup.object().shape(validate);
    });

    return (
        <>
            <Notification scopeToShow="cedip/transmit" />
            <ResponsiveHeader id="cedip.transmit" />
            <MainContainer classname="cedip" showLoader={!fetching}>
                {isDesktop && (
                    <div className="acct-number">
                        <I18n id="deposits.certificate.cedip.subtitle" />
                        {` ···${selectedCedip?.numeroCertificado?.slice(-6)}`}
                    </div>
                )}
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={transmitCedipValidation}
                    validateOnChange>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={10} className="mb-4">
                                        <FieldLabel labelText={i18n.get("cedip.transmit.beneficiary")} />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={2}
                                        columnWidth={10}
                                        rowStart={3}
                                        className="form-group">
                                        <Beneficiaries
                                            isDesktop={isDesktop}
                                            idForm={FORM_ID}
                                            beneficiaryData={transmitCedipData}
                                            actionType={types.TRANSMIT_CEDIP_BENEFICIARY}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data className="required" columnStart={2} columnWidth={5} rowStart={5}>
                                        <Field
                                            component={AmountField}
                                            labelText={`${i18n.get(`${FORM_ID}.amountField.label`)}`}
                                            idForm={FORM_ID}
                                            disable
                                            disableSelect
                                            name="amountField"
                                            data={{ options: [{ id: 1, label: i18n.get(`currency.label.${ARS}`) }] }}
                                            clearable={false}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={7} columnWidth={5} rowStart={5}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="typeTransmit"
                                            disabled
                                            type="text"
                                            maxLength="150"
                                            hidePlaceholder
                                            value={i18n.get(`cedips.transmissions.type.${values.tipoTransmision}`)}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={2}>
                                    <Button
                                        className="btn btn-outline btn-block"
                                        label="global.cancel"
                                        onClick={() => dispatch(routerActions.push("/depositsCedip"))}
                                        block
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6}>
                                    <Button
                                        type="submit"
                                        className="btn-primary"
                                        label="global.continue"
                                        disabled={!values.typeTransmit || !hasBeneficiary || !values.amountField.amount}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <TermsConditionTransmit
                    handleAccept={handleAccept}
                    handleReject={() => setOpenSidebar(false)}
                    handleClickDownloadPdf={handleClickDownloadPdf}
                />
            </Drawer>
        </>
    );
};

TransmitCedip.propTypes = {
    isDesktop: bool.isRequired,
    match: shape().isRequired,
};

export default TransmitCedip;
